module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LegalCaseWorkflow"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.workflow_type === 'brief_of_evidence') ? _c('div', {
    staticClass: "row"
  }, [_c('strong', [_vm._v("Are you sure you want to generate the Brief of Evidence?\n                "), _c('br'), _vm._v("( This will make the Case read-only and no further changes can be made)\n            ")])]) : (_vm.workflow_type === 'prosecution_brief') ? _c('div', {
    staticClass: "row"
  }, [_c('strong', [_vm._v("Are you sure you want to generate the Prosecution Brief?\n            ")])]) : (_vm.workflow_type === 'back_to_case') ? _c('div', {
    staticClass: "row"
  }, [_c('strong', [_vm._v("Are you sure you want to re-open the Case?\n            ")])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.workflow_type === 'approve_brief_of_evidence') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('strong', [_vm._v("\n                              This will forward the Case for possible legal action\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.commsLogsDocumentUrl
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Error: " + _vm._s(_vm.errorResponse))])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d424057a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/legal_case_workflow.vue
// module id = 1053
// module chunks = 0